module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAARCAMAAADub6yxAAAAXVBMVEVfY2hfY2hfY2hfY2hfY2hfY2hfY2hHcExfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2hfY2j/2S3XAAAAHnRSTlP1PCEQuxXwAOyXqJvlCoutsi36tBrKTTdtYX3V2Nrt3ghfAAAAjklEQVR42pWQwRKDIAxEI2oADUiVFrRt/v8zW406Iz31nXbeYTNZcPmJUGAmqD3/8oLa8nhvhDB0wrJqfLRCVDtx1eamheT7DZs3Xe36PPO+aMtsiGhkLDTOKVUNw1XLma7QEt3wt9ZeCotu1R9fOi0Pq+mrA+2bTLn1Eg0j8ElQyxEJCBFlZBtnmR4pfADLMBJZ14e5dgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_equipment.png
// module id = iiOs
// module chunks = 1